import React from 'react'
import { Login } from 'src/features/login'

const LoginPage: React.FC = () => {
  return <Login />
}

export default LoginPage
